import { Component, OnInit, EventEmitter, ElementRef } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { RouterPathService } from "../../../core/common/variables/router-path.service";
import { ManageProjectsAbsService } from "./manage-projects-abs.service";
import { TranslateService } from "../../common/variables/translate-service";
import { GlobalVariableService } from "../../common/variables/global-variable";
import { ImagePathService } from "../../../core/common/variables/image-path.service";
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { loadProjects, selectProject, clearAllProjects, copyProject, removeProject, planModified } from "../../store/senAppProjects.action";
import { ofType, Actions } from '@ngrx/effects';
import { SC_Input } from '../../common/input/SC_Input';
import { ProjectBrowseData, ProjectBrowseItem, ProjectBrowseOutput } from '../../common/api/ProjectBrowse';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { PageEvent } from '@angular/material/paginator';
import { PanelGetData } from '../../common/api/PanelGet';

@Component({
  selector: 'sen-app-manage-projects',
  templateUrl: './manage-projects.component.html',
  styleUrls: ['./manage-projects.component.scss']
})

export class ManageProjectsComponent implements OnInit {
  manageProjectsTabLink: { label: string, link: string }[];
  createProjectLink: string;
  activeLink: string;
  projects$: Observable<ProjectBrowseData[]>;
  selectedProject$: Observable<ProjectBrowseItem[]>;
  selectedProject: ProjectBrowseItem;
  itemsPerPage: number = 7;
  totlePages: number;
  initialPageIndex: number = 0;
  triggeredFrom: string;
  unsubscribeProject: Subscription;
  unsubscribeSelectedProject: Subscription;
  projectNameSearchString: string = SC_Input.sProject?.projectSearchName;
  copyProjectUnSubsribe: Subscription;
  removeProjectUnSubscribe: Subscription;
  planModifiedUnSubscribe: Subscription;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private routerPath: RouterPathService,
    private MPService: ManageProjectsAbsService,
    public translate: TranslateService,
    public global: GlobalVariableService,
    public imagePath: ImagePathService,
    private store: Store<any>,
    private action: Actions) {
    this.createProjectLink = this.routerPath.createProjcetPath;
    this.manageProjectsTabLink = [
      { label: 'PROJECT', link: this.routerPath.MPProjectString },
      // { label: 'BUSINESS_CASE', link: this.routerPath.MPCalculationProfitabilityString },
      { label: 'ITEM_LIST', link: this.routerPath.MPItemListString },
      { label: 'SYS_DOC_PRINT', link: this.routerPath.MPPrintSystemDocumentsString },
      // { label: 'PROPOS_PRINT', link: this.routerPath.MPPrintOfferString },
      // { label: 'INSTALL_TIME', link: this.routerPath.MPInstallationTimeString }
    ];
    if (SC_Input.sProject?.currentPage) {
      this.initialPageIndex = SC_Input.sProject.currentPage;
    }
    this.projects$ = this.store.select(state => { return state.appData.allProjects });
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
    this.triggeredFrom = this.router.getCurrentNavigation()?.extras?.state?.action;
    try {
      //if the page reached from create/edit project it resets page index
      if (this.triggeredFrom == this.global.createProject || this.triggeredFrom == this.global.editProject) {
        this.projectNameSearchString = SC_Input.sProject.projectSearchName = '';
        this.initialPageIndex = 0;
      }
    } catch { }
    this.getAllProjects(this.initialPageIndex);
  }

  ngAfterViewInit() {
    //if reached from edit/create project it defaults opens first project or opens existing project
    this.unsubscribeProject = this.projects$.subscribe((data: any) => {
      if (data && this.triggeredFrom) {
        if (this.triggeredFrom == this.global.createProject || this.triggeredFrom == this.global.editProject) {
          this.getSelectedProject(data.projects[0]);
          this.triggeredFrom = '';
          this.unsubscribeProject.unsubscribe();
        } else if (this.triggeredFrom == this.global.savePlan) {
          this.getSelectedProject(SC_Input.sProject.selectedProject);
          this.triggeredFrom = '';
          this.unsubscribeProject.unsubscribe();
        }
      }
    });

    this.unsubscribeSelectedProject = this.selectedProject$.subscribe((data: any) => {
      if (data) {
        this.selectedProject = data;
        this.global.selectedProject = true;
        if (this.global.targetPath == this.routerPath.MPItemListString) {
          this.router.navigate([this.routerPath.MPItemListPath]);
        } else {
          this.router.navigate([this.routerPath.MPProjectPath]);
        }
      }
    });

    this.copyProjectUnSubsribe = this.action.pipe(ofType(copyProject)).subscribe(() => {
      let copyAction: boolean = true;
      this.initialPageIndex = 0;
      SC_Input.sProject.currentPage = 0;
      this.getAllProjects(this.initialPageIndex);
      this.projects$.subscribe((data: any) => {
        if (data && copyAction) {
          this.getSelectedProject(data.projects[0]);
          copyAction = false;
        }
      })
    });

    this.removeProjectUnSubscribe = this.action.pipe(ofType(removeProject)).subscribe(() => {
      let deleteAction: boolean = true;
      this.projects$.subscribe((data: any) => {
        if (data && deleteAction) {
          if (data.projects.length > 1 || this.initialPageIndex == 0) {
            this.getAllProjects(this.initialPageIndex);
          } else {
            this.getAllProjects(--this.initialPageIndex);
          }
          deleteAction = false;
        }
      })
    });
    this.planModifiedUnSubscribe = this.action.pipe(ofType(planModified)).subscribe(() => {
      this.getSelectedProject(SC_Input.sProject.selectedProject)
    });
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    SC_Input.sProject.projectSearchName = this.projectNameSearchString;
    this.store.dispatch(clearAllProjects());
    this.unsubscribeSelectedProject.unsubscribe();
    this.copyProjectUnSubsribe.unsubscribe();
    this.removeProjectUnSubscribe.unsubscribe();
    this.planModifiedUnSubscribe.unsubscribe();
  }

  getAllProjects(inx: number): void {
    this.store.dispatch(loadProjects({ cmd: this.global.projectBrowse, page: ++inx, name: this.projectNameSearchString }));
  }

  projectSearchCall(searchText: Event): void {
    this.projectNameSearchString = (searchText.target as HTMLInputElement).value;
    this.initialPageIndex = 0;
    this.getAllProjects(this.initialPageIndex);
  }

  getSelectedProject(project: ProjectBrowseItem, event?: Event): void {
    if (event && this.checkSelectedProjectId(project.id)) return;
    SC_Input.sProject.selectedProject = project;
    SC_Input.sPanel = new PanelGetData();
    this.store.dispatch(selectProject({ id: project.id }));
  }

  // to avoid same project call
  checkSelectedProjectId(id: number) {
    try {
      return SC_Input.sProject.selectedProject.id == id;
    } catch {
      return false;
    }
  }

  paginationChange(event: PageEvent) {
    this.initialPageIndex = event.pageIndex;
    SC_Input.sProject.currentPage = event.pageIndex;
    this.getAllProjects(event.pageIndex);
    this.triggeredFrom = '';
  }
}
